import {Component, OnDestroy, OnInit} from '@angular/core';
import {AgentService} from '../shared/api/resources/agent/agent.service';
import {ToasterService} from '../shared/global/toaster.service';
import {CommunityService} from '../shared/api/resources/community/community.service';
import {StaticUtils} from '../shared/utils/static-utils';
import {ProtocolService} from '../shared/global/protocol.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-explore',
  templateUrl: './explore.component.html',
  styleUrls: ['./explore.component.scss']
})
export class ExploreComponent implements OnInit, OnDestroy {
  suppliersLoading = false;
  protocolAcceptedSub: any;
  suppliers: any[];
  filteredSuppliers: any[];
  statusFilter: number;
  statusOptions = [
    {value: undefined, label: 'All'},
    {value: 5, label: 'Available to connect'},
    {value: 9, label: 'Request Sent'},
    {value: 15, label: 'Connected'},
  ];
  locationFilter: string;
  locationOptions = [
    {value: undefined, label: 'All'},
  ];
  searchFilter: string;
  sendingRequestToSupplier: number;

  constructor(
    private _router: Router,
    private _agentService: AgentService,
    private _communityService: CommunityService,
    private _toasterService: ToasterService,
    private _protocolService: ProtocolService) { }

  ngOnInit() {
    this.protocolAcceptedSub = this._protocolService.protocolAccepted.subscribe(() => this.getSuppliers());
    this.getSuppliers();
  }

  ngOnDestroy() {
    if (!!this.protocolAcceptedSub) {
      this.protocolAcceptedSub.unsubscribe();
    }
  }

  getSuppliers() {
    this.suppliersLoading = true;
    this._communityService.getSuppliersToAgent().subscribe(
      (suppliers: any[]) => {
        this.suppliers = suppliers;
        this.populateLocationOptions();
        this.applySuppliersFilters();
      },
      undefined,
      () => this.suppliersLoading = false,
    );
  }

  sendRequest(supplier: any, $event?: any) {
    if ($event) {
      $event.stopPropagation();
    }
    this.sendingRequestToSupplier = supplier.id;
    this._communityService.sendConnectRequestToSupplier(supplier.id).subscribe(
      () => {
        this._toasterService.showInfo('Request sent to ' + supplier.brand);
      },
      undefined,
      () =>  {
        this.sendingRequestToSupplier = undefined;
        this.getSuppliers();
      }
    );
  }

  goToSupplier(supplier: any) {
    this._router.navigateByUrl('supplier/' + supplier.id);
  }

  populateLocationOptions() {
    this.locationOptions = [
      { value: undefined, label: 'All' }
    ];

    const uniqueLocations = Array.from(
      new Set(
        this.suppliers
          .map(s => s.location && s.location.trim().toLowerCase())
          .filter(Boolean)
      )
    ).sort((a, b) => a.localeCompare(b));

    const toTitleCase = (str: string) => {
      return str.split(' ').map((word, idx) => {
          if (idx === 0) return word.charAt(0).toUpperCase() + word.slice(1);
          if (word.length === 2) return word.toLowerCase();
          
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
    };

    this.locationOptions.push(
      ...uniqueLocations.map(loc => ({
        value: loc,
        label: toTitleCase(loc)
      }))
    );
  }

  onStatusChange(event: any) {
    this.statusFilter = event.value;
    this.applySuppliersFilters();
  }

  onLocationChange(event: any) {
    this.locationFilter = event.value;
    this.applySuppliersFilters();
  }

  onSearchChange(event: any) {
    this.searchFilter = event.target.value;
    this.applySuppliersFilters();
  }

  applySuppliersFilters() {
    this.filteredSuppliers = StaticUtils.deepCopy(this.suppliers);

    if (this.statusFilter !== undefined) {
      this.filteredSuppliers = this.filteredSuppliers.filter((supplier: any) => {
        return this.statusFilter === 5 ?
          supplier.invitationStatus === 5 || supplier.invitationStatus === 26 :
          supplier.invitationStatus === this.statusFilter;
      });
    }

    if (this.locationFilter !== undefined) {
      this.filteredSuppliers = this.filteredSuppliers.filter((supplier: any) => {
        return (
          supplier.location && supplier.location.trim().toLowerCase() === this.locationFilter.trim().toLowerCase()
        );
      });
    }

    if (this.searchFilter !== undefined && this.searchFilter !== '') {
      this.filteredSuppliers = this.filteredSuppliers.filter((supplier: any) => {
        return supplier.brand ? supplier.brand.toUpperCase().includes(this.searchFilter.toUpperCase()) : false;
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/explore/explore.component.ts